import { FC, useEffect, useState } from 'react';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import EditIcon from '@mui/icons-material/Edit';
import { Grid, TextField, Button } from '@mui/material';
import { SCUIContent } from '../../atomic/organisms';
import { SCUICustomDataGrid } from '../../atomic/molecules';
import { SCUIButton } from '../../atomic/atoms';
import Swal from 'sweetalert2';
import { useTranslation } from 'react-i18next';
import { RoleManagementDialog } from './components/RoleManagementDialog/RoleManagementDialog';
import DeleteIcon from '@mui/icons-material/Delete';
import PersonIcon from '@mui/icons-material/Person';
import { ReportDialog } from './components/ReportDialog';
import { ReportsCommand } from '../../services/command';
import { OperatorQuery, ReportsQuery } from '../../services/query';
import { SSRS } from './ssrsPageManagement.classes';

export const SsrsPageManagement: FC<any> = () => {
    const { t } = useTranslation();
    const [refresh, setRefresh] = useState(false);

    const [openEditModalDialog, setOpenEditModalDialog] = useState(false);
    const [openEditModalManagement, setOpenEditModalManagement] = useState(false);
    const [searchedReports, setSearchedReports] = useState('');
    const [searchedReport, setSearchedReport] = useState<any>();
    const [report, setReport] = useState<any>();
    const [reports, setReports] = useState<any>([]);
    const [roles, setRoles] = useState<any>();

    const onModalEditCloseManagement = () => setOpenEditModalManagement(false);
    const onModalEditCloseDialog = () => setOpenEditModalDialog(false);
    const refreshFunc = () => setRefresh((prevRefreshing) => !prevRefreshing);

    const onModalEditOpenManagement = () => setOpenEditModalManagement(true);
    const onModalEditOpenDialog = () => setOpenEditModalDialog(true);

    const GetReports = () => {
        ReportsQuery.GetListOfReportsListItem()
            .then((res: any) => {
                if (res) {
                    let parseData = res.data.map((item: any) => {
                        return {
                            reportId: item.reportId || '-',
                            reportTitle: item.reportTitle || '-',
                            reportUri: item.reportUri || '-',
                        };
                    });

                    setReports(parseData);
                    setSearchedReport(parseData);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const GetRolesListId = () => {
        OperatorQuery.GetRolesList()
            .then((res: any) => {
                if (res) {
                    setRoles(res.model.data);
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            });
    };
    const sil = async (params: any) => {
        const result = await Swal.fire({
            text: 'Bu Raporu Silmek İstiyor Musunuz?',
            cancelButtonText: t('general.cancel'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('general.delete'),
        });

        if (!result.isConfirmed) {
            return;
        }

        try {
            await ReportsCommand.DeleteReports(params);
            await Swal.fire('Silindi!', ' ', 'success');
            refreshFunc();
        } catch (error: any) {
            console.log('Hata :>> ', error);
        }
    };

    useEffect(() => {
        GetReports();
    }, [refresh]);
    useEffect(() => {
        GetRolesListId();
    }, []);

    const requestSearchMpConfig = (searchedVal: any) => {
        setSearchedReports(searchedVal.target.value);
        let filteredRoles = searchedReport.filter(
            (o: any) => o.reportTitle.toLowerCase().indexOf(searchedVal.target.value.toLowerCase()) !== -1
        );
        setReports(filteredRoles);
    };
    const columns: ExtendedGridColDef[] = [
        {
            field: 'reportId',
            headerName: 'ID',
            width: 90,
            flex: 1,
            hide: true,
            renderCell: (params: any) => (
                <span className={SSRS.cellReportId} data-report-id={params.row.reportId}>
                    {params.row.reportId}
                </span>
            ),
        },
        {
            field: 'reportTitle',
            headerName: 'Rapor İsmi',
            width: 150,
            flex: 1,
            renderCell: (params: any) => (
                <span
                    className={SSRS.cellReportTitle}
                    data-report-id={params.row.reportId}
                    data-report-title={params.row.reportTitle}
                >
                    {params.row.reportTitle}
                </span>
            ),
        },
        {
            field: 'YonetimEkranı',
            headerName: 'Role',
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params: any) => {
                const onclick = () => {
                    setReport(params.row);
                    onModalEditOpenManagement();
                };

                return (
                    <div className={SSRS.cellRole}>
                        <Button
                            onClick={onclick}
                            className={SSRS.btnOpenRoleDialog}
                            data-report-id={params.row.reportId}
                        >
                            <PersonIcon />
                        </Button>
                    </div>
                );
            },
        },
        {
            field: 'düzenle',
            headerName: t('general.edit'),
            width: 160,
            headerAlign: 'center',
            flex: 1,
            align: 'center',
            renderCell: (params: any) => {
                const onclick = () => {
                    setReport(params.row);
                    onModalEditOpenDialog();
                };

                return (
                    <div className={SSRS.cellEdit}>
                        <Button
                            onClick={onclick}
                            className={SSRS.btnEditReport}
                            data-report-id={params.row.reportId}
                        >
                            <EditIcon />
                        </Button>
                    </div>
                );
            },
        },
        {
            field: 'sil',
            headerName: t('general.delete'),
            width: 160,
            flex: 1,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params: any) => {
                const onclick = () => {
                    console.info(params.row.reportId);
                    console.info(params.row);
                    sil(params.row.reportId);
                };
                return (
                    <div className={SSRS.cellDelete}>
                        <Button
                            onClick={onclick}
                            className={SSRS.btnDeleteReport}
                            data-report-id={params.row.reportId}
                        >
                            <DeleteIcon />
                        </Button>
                    </div>
                );
            },
        },
    ];

    return (
        <SCUIContent className={SSRS.page}>
            <RoleManagementDialog
                selectedRow={report}
                open={openEditModalManagement}
                onClose={onModalEditCloseManagement}
                roles={roles}
            />
            <ReportDialog
                selectedRow={report}
                open={openEditModalDialog}
                onClose={onModalEditCloseDialog}
                refresh={refreshFunc}
            />
            <Grid container direction="row" className={SSRS.root}>
                <Grid
                    className={SSRS.header}
                    size={{
                        lg: 10,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <h1 className={`headtxt ${SSRS.title}`}>{t('general.reports')} </h1>
                </Grid>
                <Grid
                    className={SSRS.headerActions}
                    size={{
                        lg: 2,
                        md: 6,
                        xs: 6,
                    }}
                >
                    <SCUIButton
                        className={SSRS.btnAddReport}
                        text={'Rapor Ekle'}
                        type="primary"
                        sizeType="fixed"
                        size={'m'}
                        onClick={() => {
                            setReport([]);
                            onModalEditOpenDialog();
                        }}
                    />
                </Grid>
                <Grid
                    className={SSRS.searchBox}
                    sx={{ marginBottom: 1, marginTop: 1 }}
                    size={{
                        xs: 12,
                        sm: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <TextField
                        className={SSRS.inputSearch}
                        label={'Key'}
                        value={searchedReports}
                        onChange={(searchVal) => requestSearchMpConfig(searchVal)}
                        fullWidth
                    />
                </Grid>
                <Grid
                    className={SSRS.grid}
                    size={{
                        sm: 12,
                        md: 12,
                        lg: 12,
                        xl: 12,
                    }}
                >
                    <SCUICustomDataGrid
                        rows={reports}
                        randomId
                        columns={columns}
                        initialState={{
                            sorting: {
                                sortModel: [
                                    {
                                        field: 'id',
                                        sort: 'asc',
                                    },
                                ],
                            },
                        }}
                    />
                </Grid>
            </Grid>
        </SCUIContent>
    );
};
